export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/rental/index/resources/computed.js